import {
    Component,
    OnInit,
    ViewContainerRef,
    ViewChild,
    TemplateRef,
} from '@angular/core';
import { SiteServices } from '../../services/siteservices';

import { Router, Event as NavigationEvent } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { Location } from '@angular/common';

import { setTimeout } from 'timers';

import { ModalDialogService, SimpleModalComponent } from 'ngx-modal-dialog';
import { ProviderContext } from '../../data/Entities';
import { forEach } from '@angular/router/src/utils/collection';
import { FileUploader } from 'ng2-file-upload';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Helpers } from '../../services/Helpers';

declare var appConfig: any;

@Component({
    selector: 'userfrm',
    templateUrl: 'templates/get/Product/product_detail',
})
export class ProductDetailFrm implements OnInit {
    public devicerows: Array<any>;
    public hostrows: Array<any>;

    /**/
    public possibleproducts: Array<any> = [];
    public possibleproductproviders: Array<any> = [];
    public possibleproductprovidersObj: any;
    public nameWords: Array<string> = [];
    public filterWords: Array<string> = [];
    public filterWordsJoined: string = '';
    public searchC11 = '';
    public searchC22: string;
    public searchC33: string;
    public c1List: any = [];
    public c2List: any = [];
    public c3List: any = [];
    public fList: any = [];
    public rows: any = [];
    public origProductLocationMapIDs: any = [];
    public origShelfDisplayPositonNameKeys: any = [];
    public searchC1 = '';
    public searchC2: string;
    public searchC3: string;
    public searchF: string; // functional
    public c11List: any = [];
    public shopMapTableData: any = [];
    public c22List: any = [];
    public c33List: any = [];

    public searchText: string;
    public searchTargetText: string;
    public sourceProd: any;
    public sourceProdArr: any = [];

    public targetList: any = [];
    public promotionUrl: string;
    public promotionPicture: any;

    public errstr: string;
    public entity: any = { Address: {}, PriceHistoryList: [] };
    public entityProviders: Array<any> = [];
    public entityProductEdit: any = {};
    public modalRef: BsModalRef;
    public submitted = false;
    public isAdmin = true;
    public isRokshProductsAudited = false;
    public decideBaseProduct = false;

    publicnextProdid: number;
    public productNameEdit: boolean;
    public productDescriptionEdit: boolean;
    public minWSEdit: boolean;
    public maxWSEdit: boolean;
    public unitEdit: boolean;
    parser = new DOMParser();

    public lineChartData: Array<any> = [{ data: [], label: 'Árak' }];
    public lineChartLabels: Array<any> = [];
    public lineChartOptions: any = {
        responsive: true,
    };

    public isupload = true;

    @ViewChild('mergetemplate')
    private mergeTemplateRef: TemplateRef<any>;

    public lineChartColors: Array<any> = [
        {
            // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        },
        {
            // dark grey
            backgroundColor: 'rgba(77,83,96,0.2)',
            borderColor: 'rgba(77,83,96,1)',
            pointBackgroundColor: 'rgba(77,83,96,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(77,83,96,1)',
        },
        {
            // grey
            backgroundColor: 'rgba(148,159,177,0.2)',
            borderColor: 'rgba(148,159,177,1)',
            pointBackgroundColor: 'rgba(148,159,177,1)',
            pointBorderColor: '#fff',
            pointHoverBackgroundColor: '#fff',
            pointHoverBorderColor: 'rgba(148,159,177,0.8)',
        },
    ];
    public lineChartLegend = false;
    public lineChartType = 'line';

    public promoImgWidth;
    public promoImgHeight;

    public MediaServicesUrl: string;
    public uploader: FileUploader;
    public uploader2: FileUploader;
    name = 'ng4-ckeditor';
    ckeConfig: any;
    mycontent: string;
    log: string = '';
    @ViewChild('myckeditor') ckeditor: any;

    constructor(
        public siteServices: SiteServices,
        private route: ActivatedRoute,
        private router: Router,
        private modalService: BsModalService,
        public location: Location,
        public viewRef: ViewContainerRef,
        public modalService2: ModalDialogService
    ) {
        this.mycontent = `<p>My html content</p>`;

        this.MediaServicesUrl = appConfig.MediaServicesUrl;

        this.uploader = new FileUploader({
            url: 'interface/uploadimage/',
        });

        this.uploader2 = new FileUploader({
            url: 'interface/uploadimage/',
        });

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETROOTCATEGORYLIST',
            {},
            (data) => {
                this.c1List = data.TagObject;
                this.c11List = data.TagObject;
            }
        );
    }

    ngOnInit() {
        this.ckeConfig = {
            allowedContent: false,
            extraPlugins: 'divarea',
            forcePasteAsPlainText: true,
        };

        this.refresh();

        this.uploader.onErrorItem = this.uploader2.onErrorItem = (
            item,
            response,
            status,
            headers
        ) => {
            this.errstr = 'Hibás feltöltés (' + status + ')';
            this.isupload = false;
        };
        this.uploader.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);
            if (r.ErrStr) {
                this.errstr = r.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }
            this.entity.MediaGUID = r.Tag;
            this.saveProductField('MediaGUID');
        };

        this.uploader2.onSuccessItem = (item, response, status, headers) => {
            this.isupload = false;
            let r = JSON.parse(response);
            if (r.ErrStr) {
                this.errstr = r.ErrStr;
                this.siteServices.error(this.errstr);
                return;
            }

            this.saveProductMedia(r.Tag);
        };

        this.uploader.onBeforeUploadItem = this.uploader2.onBeforeUploadItem = (
            fileItem
        ) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader2.onAfterAddingFile = this.uploader.onAfterAddingFile = (
            fileItem
        ) => {
            this.errstr = '';
            this.isupload = true;
        };
        this.uploader.options['autoUpload'] = true;
        this.uploader2.options['autoUpload'] = true;
    }

    onEventOrRequest(event: any) {
        this.ckeditor.instance.setData('');
    }

    onChange($event: any): void {
        console.log('onChange');
        //this.log += new Date() + "<br />";
    }

    onPaste($event: any): void {
        console.log('onPaste');
        //this.log += new Date() + "<br />";
    }

    refresh() {
        this.route.params.subscribe((params) => {
            this.siteServices.provider_GetDataByID(
                'product',
                params.id,
                null,
                (data) => {
                    this.entity = data.TagObject;
                    this.initChart();
                    this.initShopMapTable();
                }
            );

            this.siteServices.provider_Execute(
                'PRODUCT',
                'GETPRODUCTEDIT',
                params.id,
                (data) => {
                    this.entityProductEdit = data.TagObject;
                    if (this.entityProductEdit.PromotionPicture) {
                        const img = new Image();
                        img.onload = () => {
                            this.promoImgWidth = img.width;
                            this.promoImgHeight = img.height;
                        };
                        this.entityProductEdit.PromotionPicture =
                            'data:image/png;base64,'.concat(
                                this.entityProductEdit.PromotionPicture
                            );
                        img.src = this.entityProductEdit.PromotionPicture;
                    }
                }
            );
        });
    }

    initShopMapTable() {
        if (this.entity.ProductProvider[0].ProductProviderID) {
            this.siteServices.provider_Execute(
                'PRODUCT',
                'GETSHOPMAPTABLEDATA',
                this.entity.ProductProvider[0].ProductProviderID,
                (data) => {
                    this.shopMapTableData = data.TagObject;
                }
            );
        }
    }

    changeImg(newImgURL) {
        if (newImgURL) {
            this.entity.MediaUrlL = newImgURL;
            this.siteServices.provider_Execute(
                'PRODUCT',
                'CHANGEPRODUCTIMAGE',
                this.entity.ProductID + '#' + newImgURL,
                (data) => {
                    console.log(data);
                    alert('The image has changed');
                }
            );
        }
    }

    initChart() {
        this.lineChartData[0].data = this.entity.PriceHistoryList.map(
            (res: any) => {
                return res.Price;
            }
        );

        this.lineChartLabels = this.entity.PriceHistoryList.map((res: any) => {
            return res.Label;
        });

        this.entity.ProductProvider.forEach((p) => {
            p.lineChartData = [
                {
                    data: p.PriceHistoryList.map((res: any) => {
                        return res.Price;
                    }),
                },
            ];
            p.lineChartLabels = p.PriceHistoryList.map((res: any) => {
                return res.Label;
            });
        });

        this.nameWords = this.entity.ProductName.split(' ');
    }

    saverange(newValue) {
        this.filterWords = newValue.split(' ');
        this.filterWordsJoined = this.filterWords.join(' ');
        console.log(this.filterWords);
    }

    addToFilterName(row: any) {
        if (this.filterWords.indexOf(row) == -1) {
            this.filterWords.push(row);
        }

        console.log(this.filterWords);
        this.filterWordsJoined = this.filterWords.join(' ');
        console.log(this.filterWordsJoined);
    }

    checkExistingProducts() {
        window.location.href = window.location.href + '#cselendzs';
        /**Betölti a Roksh termékek*/

        console.log(this.entity);
        this.possibleproducts = [];
        var tmpPossibleproducts = [];

        this.entity.ProductProvider.forEach(function (value) {
            console.log(value.ProviderID);
            tmpPossibleproducts.push(value.ProviderID);
        });
        this.entityProviders = tmpPossibleproducts;
        console.log(this.entityProviders);

        this.siteServices.provider_GetMissingSimilarProducts(
            'getMissingSimilarProviderProducts',
            this.entity.ProductProvider[0].ProductProviderID,
            this.filterWords.join('_'),
            '',
            (data) => {
                var tmpShit = data.TagObject;
                if (tmpShit.length > 0) {
                    this.possibleproducts.push(tmpShit);
                    console.log(tmpShit);
                }
            }
        );
        console.log(this.possibleproducts);
    }

    public decideProducts() {
        this.decideBaseProduct = true;
    }

    //Leszedjük az éppen auditált termék providereit és folytatjuk a másik auditját
    public explodeThisProduct(item) {
        console.log(item);

        this.siteServices.provider_Execute(
            'PRODUCT',
            'EXPLODETHISPRODUCT',
            this.entity.ProductID,
            (data) => {
                console.log(data);
                alert(data);
                this.router
                    .navigate(['productedit', item.ProductID])
                    .then((_ev) => {});
            }
        );
    }

    //Leszedjük a másik termék providereit és folytatjuk az auditálást
    public explodeOtherProduct(item) {
        console.log(item);

        this.siteServices.provider_Execute(
            'PRODUCT',
            'EXPLODETHISPRODUCT',
            item.ProductID,
            (data) => {
                this.startChallenge();
            }
        );
    }

    startChallenge() {
        this.isRokshProductsAudited = true;

        /**Betölti a többi kis providert*/
        this.possibleproductprovidersObj = null;

        this.siteServices.provider_GetMissingSimilarProviderProducts(
            'getMissingSimilarProviderProducts',
            this.entity.ProductID,
            this.filterWords.join('_'),
            '1',
            (data) => {
                console.log(data);
                this.possibleproductprovidersObj = data.TagObject;
                console.log(this.possibleproductprovidersObj);
            }
        );
        console.log(this.possibleproductprovidersObj);
    }

    detachProduct(row: any) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DETACH',
            row.ProductProviderID,
            (data) => {
                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success('Leválasztás OK');
                }, 500);
            }
        );
    }

    public setGroupCategory() {
        var arr = [this.entity.ProductID];

        let key = null;

        if (this.searchC33) {
            key = this.searchC33;
        } else if (this.searchC22) {
            key = this.searchC22;
        } else if (this.searchC11) {
            key = this.searchC11;
        }

        if (!key) {
            this.siteServices.error('Nincs célkategória kiválasztva');
            return;
        }

        console.log(arr);
        console.log(key);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETCATEGORY',
            { productArr: arr, targetCategory: key },
            (data) => {
                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success(
                        'Átmozgatás OK -' + arr.length + ' db.'
                    );
                }, 500);
            }
        );
    }

    matchProduct(item: any) {
        //console.log(item);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'MERGEPRODPROV',
            item.ProductProviderID + '_' + this.entity.ProductID,
            (data) => {}
        );
        setTimeout((x) => {
            this.siteServices.success('Összerendelés OK');
            var i = 0;
            this.possibleproductprovidersObj.forEach((p) => {
                console.log(p[0].ProviderID + '___' + item.ProviderID);
                if (p[0].ProviderID == item.ProviderID) {
                    p = [];
                    console.log(i);
                    this.possibleproductprovidersObj.splice(i, 1);
                }
                i++;
            });

            console.log(this.possibleproductprovidersObj);
            this.refresh();
        }, 2000);
    }

    notMatchedRow(prid) {
        var i = 0;
        var provid = prid;
        this.possibleproductprovidersObj.forEach((p) => {
            console.log(p[0].ProviderID + '___' + provid);
            if (p[0].ProviderID == provid) {
                p = [];
                console.log(i);
                this.possibleproductprovidersObj.splice(i, 1);
            }
            i++;
        });
        this.refresh();
    }

    saveProductField(fieldName: string) {
        this.entity.FieldNameToSave = fieldName;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVEPRODUCTFIELD',
            this.entity,
            (data) => {
                this.productNameEdit = false;
                this.minWSEdit = false;
                this.maxWSEdit = false;
                this.unitEdit = false;

                this.refresh();

                setTimeout((x) => {
                    this.siteServices.success('OK');
                }, 500);
            }
        );
    }

    saveProductFieldExt(fieldName: string) {
        this.entity.ProductDetails.FieldNameToSave = fieldName;

        console.log(this.entity.ProductDetails);

        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVEPRODUCTFIELDEXT',
            this.entity.ProductDetails,
            (data) => {
                this.productDescriptionEdit = false;

                this.refresh();

                setTimeout((x) => {
                    this.siteServices.success('OK');
                }, 500);
            }
        );
    }

    /**
     * Convert a template string into HTML DOM nodes
     * @param  {String} str The template string
     * @return {Node}       The template HTML
     */
    parseHtml(str, id) {
        if (str) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            let myContainer = document.getElementById(id) as HTMLInputElement;
            myContainer.innerHTML = doc.body.innerHTML;
        }
        //return doc.body.innerHTML;
    }

    save() {
        /*  this.submitted = true;
        if (!frm.valid) {
            this.siteServices.error("Hibás kitöltés!");
            return;
        }
        */

        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVEPRODUCTEDIT',
            this.entityProductEdit,
            (data) => {
                window.scrollTo(0, 0);
                setTimeout((x) => {
                    this.siteServices.success('OK');
                    this.entity = data.TagObject;
                }, 50);
            }
        );
    }

    deleteItem(row: any) {
        this.sure(this.viewRef, (x) => {
            this.siteServices.provider_Execute(
                'PRODUCT',
                'DELETESHOPMAPRELATIONSHIP',
                row.ProductProviderProductLocationMapID,
                (x) => {
                    row.ProductProviderProductLocationMapID = null;
                    row.ProductLocationMapID = null;
                    row.ProductLocationMapImageURL = null;
                    row.ShelfDisplayPositonNameKey = null;
                    this.siteServices.success('Törlés OK');
                }
            );
        });
    }

    saveItem(row: any) {
        row.ProductProviderID = this.entity.ProductProvider[0].ProductProviderID;
        var plm = row.ProductLocationMapList.find(x => x.ProductLocationMapId === row.ProductLocationMapID);
        let imageURL = null;
        if (plm) {
            imageURL = plm.ImageURL;
        }
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVESHOPMAPRELATIONSHIP',
            row,
            (x) => {
                row._edited = false;
                row.ProductProviderProductLocationMapID = x.TagObject;
                row.ProductLocationMapImageURL = imageURL;
                this.siteServices.success('Mentés OK');
            }
        );
    }

    makeMainPhoto(productProviderID) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETMAINIMAGE',
            productProviderID,
            (data) => {
                this.refresh();
                setTimeout((x) => {
                    this.siteServices.success('Beállítás OK');
                }, 500);
            }
        );
    }

    onFileSelected(event) {
        const reader = new FileReader();
        const file = event.target.files[0];
        reader.readAsDataURL(file);
        reader.onload = () => {
            const img = new Image();
            img.onload = () => {
                this.promoImgWidth = img.width;
                this.promoImgHeight = img.height;
            };
            img.src = <string>reader.result;
            console.log(reader.result);
            this.entityProductEdit.PromotionPicture = reader.result;
        };
    }

    setPromotion() {
        if (
            !this.promoImgWidth ||
            (this.promoImgHeight && this.promoImgWidth <= 0) ||
            this.promoImgHeight <= 0
        ) {
            this.siteServices.error(
                'Tölts fel egy promóciós képet a mentéshez!'
            );
            return;
        }

        const imageRatio =
            Math.round((this.promoImgWidth / this.promoImgHeight) * 100) / 100;

        if (imageRatio < 5.5 || imageRatio > 6.5) {
            this.siteServices.error(
                `A Promóciós képnek az aránya (5,5 x 1) és (6,5 x 1) között kell lennie 'Szélesség x Magasság'! Aktuális kép méret: ${this.promoImgWidth} x ${this.promoImgHeight}, és az arány: ${imageRatio}!`
            );
            return;
        }

        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETPROMOTION',
            this.entityProductEdit,
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció mentve');
                }, 50);
            }
        );
    }

    delPromotion() {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'DELPROMOTION',
            this.entityProductEdit,
            (data) => {
                setTimeout((x) => {
                    this.siteServices.success('Promóció törölve');
                    this.entityProductEdit = data.TagObject;
                }, 50);
            }
        );
    }

    public chgcat1(ev) {
        const cid = ev.target.value;

        this.c2List = [];
        this.searchC2 = '';
        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }

        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c2List = data.TagObject.ChildList;
            }
        );
    }

    public chgcat2(ev) {
        const cid = ev.target.value;

        this.c3List = [];
        this.searchC3 = '';
        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c3List = data.TagObject.ChildList;
                if (this.c3List.length === 0) {
                    // LEVÉL - lehet gyneve
                    this.siteServices.provider_Execute(
                        'PRODUCT',
                        'GETFUNCTIONALNAMES',
                        { targetCategory: cid },
                        (data2) => {
                            this.fList = data2.TagObject;
                        }
                    );
                }
            }
        );
    }

    public chgcat3(ev) {
        const cid = ev.target.value;

        this.fList = [];
        this.searchF = '';

        if (!cid) {
            return;
        }
        this.siteServices.provider_Execute(
            'PRODUCT',
            'GETFUNCTIONALNAMES',
            { targetCategory: cid },
            (data) => {
                this.fList = data.TagObject;
            }
        );
    }

    public chgcat11(ev) {
        const cid = ev.target.value;
        this.c33List = [];
        this.searchC33 = '';
        if (!cid) {
            this.c22List = [];
            this.searchC22 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c22List = data.TagObject.ChildList;
                this.searchC22 = '';
            }
        );
    }

    public chgcat22(ev) {
        const cid = ev.target.value;
        if (!cid) {
            this.c33List = [];
            this.searchC33 = '';
            return;
        }
        this.siteServices.provider_Execute(
            'CATEGORY',
            'GETCATEGORYBYID',
            { CategoryID: cid },
            (data) => {
                this.c33List = data.TagObject.ChildList;
                this.searchC33 = '';
            }
        );
    }

    public mergeProduct() {
        this.sourceProd = this.entity;
        this.sourceProdArr = this.entity.ProductName.split(' ');

        this.targetList = [];
        const a = this.entity.ProductName.split(' ');
        this.searchTargetText = this.filterWords.join(' ');

        if (
            this.searchText &&
            this.searchText
                .toLowerCase()
                .startsWith(this.searchTargetText.toLowerCase())
        ) {
            this.searchTargetText = this.searchText;
        }

        // + (a.length > 1 ? " " + a[1] : "");
        this.modalRef = this.modalService.show(this.mergeTemplateRef, {
            class: 'modal-lg',
        });
        this.searchTargetList();
    }

    public searchTargetList() {
        const dtx2: ProviderContext = new ProviderContext({
            ProviderCode: 'PRODUCT',
            SortField: 'ProductName',
            IsAsc: true,
            ItemsPerPage: 100000,
        });

        dtx2.addFilter('ProductName', this.searchTargetText);
        // dtx2.addFilter("CategoryID", this.sourceProd.CategoryID);
        dtx2.addFilter('MatchSourceProductID', this.sourceProd.ProductID);
        this.siteServices.inProgress = true;
        this.siteServices.provider_Execute(
            'PRODUCT',
            'FINDMATCHING',
            dtx2,
            (data) => {
                // szürés hasonló bolt
                this.targetList = data.TagObject;
                this.siteServices.inProgress = false;
            }
        );
    }

    public addSearch(token: string) {
        this.searchTargetText += ' ' + token;
    }

    public doMerge(targetProd: any) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'MERGE',
            {
                sourceID: this.sourceProd.ProductID,
                targetID: targetProd.ProductID,
            },
            (data) => {
                console.log(data);
                this.router
                    .navigate(['productedit', data.TagObject])
                    .then((_ev) => {});
                this.siteServices.success('Összerendelés OK');
                this.modalRef.hide();
                this.refresh();
            }
        );
    }

    public setStatus() {
        console.log(this.entity);
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SETSTATUS',
            { productArr: [this.entity.ProductID] },
            (data) => {
                // this.refresh();
                // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
            }
        );

        setTimeout((x) => {
            this.siteServices.provider_Execute(
                'PRODUCT',
                'GETNEXTPRODID',
                this.entity.ProductID,
                (data) => {
                    console.log(data);
                    this.publicnextProdid = data.TagObject;
                    console.log(this.publicnextProdid);
                    this.router
                        .navigate(['productedit', this.publicnextProdid])
                        .then((_ev) => {});
                    // this.refresh();

                    // setTimeout(x => { this.siteServices.success("Beállítás OK"); }, 500);
                }
            );
            scroll(0, 0);
        }, 500);
    }

    toggleIsWeightStepFixed() {
        this.entity.IsWeightStepFixed = !this.entity.IsWeightStepFixed;
        this.saveProductField('IsWeightStepFixed');
    }

    delProdMedia(productMediaID: number) {
        this.sure(this.viewRef, (x) => {
            this.siteServices.provider_Execute(
                'PRODUCT',
                'DELPRODUCTMEDIA',
                {
                    ProductID: this.entity.ProductID,
                    ProductMediaID: productMediaID,
                },
                (data) => {
                    Helpers.removeByKey(
                        this.entity.ProductMediaList,
                        productMediaID,
                        'ProductMediaID'
                    );
                }
            );
        }); //sure
    }

    public sure(viewRef: ViewContainerRef, clbFunc: Function) {
        const actionButtons = [
            {
                text: 'igen',
                onAction: () => {
                    clbFunc();
                    return true;
                },
            },
            {
                text: 'nem',
                onAction: () => {
                    return true;
                },
            },
        ];

        this.modalService2.openDialog(viewRef, {
            title: 'Biztos vagy benne?',
            childComponent: SimpleModalComponent,
            actionButtons: actionButtons,
            data: { text: '' },
        });
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(
            this.entity.ProductMediaList,
            event.previousIndex,
            event.currentIndex
        );

        let arr = this.entity.ProductMediaList.map((x) => x.ProductMediaID);

        this.siteServices.provider_Execute(
            'PRODUCT',
            'UPDATEMEDIALISTPOSITION',
            {
                ProductID: this.entity.ProductID,
                ProductMediaIDList: arr,
            },

            (data) => {}
        );
    }

    saveProductMedia(mediaGUID: string) {
        this.siteServices.provider_Execute(
            'PRODUCT',
            'SAVEPRODUCTMEDIA',
            { ProductID: this.entity.ProductID, MediaGUID: mediaGUID },
            (data) => {
                this.entity.ProductMediaList.push(data.TagObject);
            }
        );
    }
}
